function sorguDizgesi(s) {
    const p = new URLSearchParams();
    if (s.sayfa)
        p.set('sayfa', String(s.sayfa));
    if (s.boyut)
        p.set('boyut', String(s.boyut));
    if (s.noktaId)
        p.set('noktaId', s.noktaId);
    if (s.aktif !== undefined)
        p.set('aktif', String(s.aktif));
    const q = p.toString();
    return q ? `?${q}` : '';
}
export async function fiyatKurallariniListele(istemci, sorgu = {}) {
    return istemci.istek(`/fiyat-kurallari${sorguDizgesi(sorgu)}`);
}
export async function fiyatKuralGetir(istemci, id) {
    return istemci.istek(`/fiyat-kurallari/${id}`);
}
export async function fiyatKuralOlustur(istemci, giris) {
    return istemci.istek('/fiyat-kurallari', {
        method: 'POST',
        body: JSON.stringify(giris),
    });
}
export async function fiyatKuralGuncelle(istemci, id, giris) {
    return istemci.istek(`/fiyat-kurallari/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(giris),
    });
}
export async function fiyatKuralSil(istemci, id) {
    return istemci.istek(`/fiyat-kurallari/${id}`, { method: 'DELETE' });
}
//# sourceMappingURL=fiyat-kurallari.js.map